import { jsx } from 'panel';
import { WarningEl } from 'common/components/warning';
export function template() {
  return jsx("div", {
    sel: '.warning-hero-container'
  }, jsx(WarningEl, {
    attrs: {
      'cta-href': this.attr("cta-href"),
      'cta-text': this.attr("cta-text"),
      'header-text': this.attr("header-text"),
      theme: this.helpers.getTheme(),
      'img-src': this.helpers.getImgSrc(),
      'body-text': this.helpers.getBodyText()
    },
    on: {
      ctaClick: this.helpers.handleCtaClick
    }
  }, jsx("slot", null)));
}